import React, { FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  TextField,
  useTheme,
} from "@mui/material";

export interface ConfirmDialogProps
  extends Omit<
    DialogProps,
    "onClose" | "open" | "style" | "inputValue" | "handler"
  > {
  title: string;
  description?: string;
  subtext?: string;
  onConfirm: (onClose: () => void, value?: string) => void;
  onClose: () => void;
  open?: boolean;
  inputValue?: string;
  handler?: (value: string) => void;
  cancelText?: string;
  confirmText?: string;
  withCancelAction?: boolean;
}

export const ConfirmDialog: FC<ConfirmDialogProps> = (props) => {
  const { palette } = useTheme();
  const {
    title,
    description,
    subtext,
    sx,
    onConfirm,
    onClose,
    inputValue,
    handler,
    open,
    cancelText = "Disagree",
    confirmText = "Agree",
    withCancelAction = true,
    ...rest
  } = props;

  const [value, setValue] = React.useState<string | undefined>(inputValue);

  return (
    <Dialog onClose={onClose} {...rest} sx={sx || {}} open={open || false}>
      <DialogTitle color={palette.grey[100]}>{title}</DialogTitle>
      <DialogContent>
        {description && (
          <DialogContentText
            id="alert-dialog-description"
            padding={0}
            margin="10px 0 20px"
            color={palette.grey[200]}
            dangerouslySetInnerHTML={{ __html: description }}
          ></DialogContentText>
        )}
        {subtext && (
          <DialogContentText
            id="alert-dialog-subtext"
            padding={0}
            margin="-10px 0 20px"
            sx={{ fontStyle: "italic" }}
            color={palette.grey[200]}
          >
            {subtext}
          </DialogContentText>
        )}
        {inputValue != undefined && (
          <TextField
            id="notes"
            type="text"
            margin="dense"
            variant="outlined"
            rows={4}
            value={value}
            onChange={(e) => setValue!(e.target.value)}
            fullWidth={true}
            multiline
            style={{ width: "320px" }}
          />
        )}
      </DialogContent>
      <DialogActions>
        {withCancelAction && (
          <Button onClick={onClose} data-testid="close-button">
            {cancelText}
          </Button>
        )}
        <Button
          onClick={() => onConfirm(onClose, value)}
          variant="contained"
          data-testid="confirm-button"
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
